export class Paging {
  constructor(currentPage, nextPage, prevPage, totalCount, totalPages, perPage) {
    this.currentPage = currentPage;
    this.nextPage = nextPage;
    this.prevPage = prevPage;
    this.totalCount = totalCount;
    this.totalPages = totalPages;
    this.perPage = perPage;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Paging(input.current_page, input.next_page, input.prev_page, input.total_count, input.total_pages, input.per_page)
    }

    return new Paging();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Paging.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Paging.fromApiObject(input)];
    }

    return [];
  }

  static fromRaw(currentPage, total, maxItemInPage) {
    const totalPages = Math.ceil(total / maxItemInPage);
    const nextPage = currentPage + 1 < totalPages ? currentPage + 1 : totalPages;
    const prevPage = currentPage > 1 ? currentPage - 1 : 1;
    return new Paging(currentPage, nextPage, prevPage, total, totalPages)
  }
}